import { useState } from 'react'
import {
  emptyMeetingDraft,
  type MeetingDraft,
  MeetingFields,
  type MeetingScope,
} from '@/entities/meeting'
import { dateTimeInputToIso } from '@/shared/lib'
import { Button } from '@/shared/ui/button'
import { Dialog } from '@/shared/ui/dialog'
import { toast } from '@/shared/ui/toast'
import { useCreateMeeting } from '../api/create'

interface CreateMeetingDialogProps {
  scope: MeetingScope
  open: boolean
  onClose: () => void
}

export function CreateMeetingDialog({ scope, open, onClose }: CreateMeetingDialogProps) {
  const create = useCreateMeeting(scope)
  const [draft, setDraft] = useState<MeetingDraft>(emptyMeetingDraft)
  const [error, setError] = useState('')

  function submit() {
    if (!draft.title.trim()) return setError('Укажите тему')
    // Бэк ждёт when как RFC3339 date-time; инпут отдаёт настенное время без
    // зоны — моментом его делает зона устройства того, кто его набрал.
    const when = dateTimeInputToIso(draft.when)
    if (!when) return setError('Укажите дату и время')
    setError('')
    create.mutate(
      {
        title: draft.title.trim(),
        when,
        ...(draft.location.trim() ? { location: draft.location.trim() } : {}),
        ...(draft.participants.trim() ? { participants: draft.participants.trim() } : {}),
        ...(draft.url.trim() ? { url: draft.url.trim() } : {}),
        ...(draft.notes.trim() ? { notes: draft.notes.trim() } : {}),
        ...(draft.customer_visible ? { customer_visible: true } : {}),
        ...(draft.attachments.length ? { attachments: draft.attachments } : {}),
      },
      {
        onSuccess: () => {
          toast.success('Встреча добавлена')
          onClose()
        },
        onError: () => toast.error('Не удалось добавить встречу'),
      },
    )
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Новая встреча"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={create.isPending}>
            Отмена
          </Button>
          <Button onClick={submit} disabled={create.isPending}>
            {create.isPending ? 'Добавляем…' : 'Добавить'}
          </Button>
        </>
      }
    >
      <MeetingFields value={draft} onChange={setDraft} {...(error ? { error } : {})} />
    </Dialog>
  )
}
